import { render, staticRenderFns } from "./XiaoFangYanGan.vue?vue&type=template&id=1fa84ed5&scoped=true&"
import script from "./XiaoFangYanGan.vue?vue&type=script&lang=js&"
export * from "./XiaoFangYanGan.vue?vue&type=script&lang=js&"
import style0 from "./XiaoFangYanGan.vue?vue&type=style&index=0&id=1fa84ed5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa84ed5",
  null
  
)

export default component.exports